<!--短信管理页面-->
<template>
    <div style="height: 100%;width: 100%">
        <div>

            <van-sticky><!-- 粘性布局，顶部的位置固定 -->
                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">

                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="18" style="padding-top: 10px">
                            <!-- 搜索组件 -->
                            <Select
                                    size="small"
                                    placeholder="选择SIM卡号"
                                    v-model="simNum"
                                    filterable
                                    remote
                                    :remote-method="searchSim"
                                    :loading="searchSimLoading"
                                    style="width: 170px; margin-right: 5px;"
                                    clearable>
                                <Option v-for="(option, index) in searchSimList" placeholder="输入SIM卡号后6位"
                                        :value="option.simNum" :key="index">{{option.simNum}}
                                </Option>
                            </Select>
                            <Button type="primary" size="small" style="margin-right: 10px;" @click="onSearchClick">查询
                            </Button>
                        </van-col>
                        <!--                        <van-col span="3">-->
                        <!--                            <div style="padding: 17px">-->
                        <!--                                &lt;!&ndash; icon图标，刷新页面 &ndash;&gt;-->
                        <!--                                <van-icon name="replay" size="15px" @click="reststart"/>-->
                        <!--                            </div>-->
                        <!--                        </van-col>-->
                    </van-row>

                </div>
            </van-sticky>
        </div>


        <div style="display: flex">

            <div>
                <Button size="small" @click="value2=true" type="primary">历史查询</Button>
                <Drawer title="历史查询SIM卡号" placement="left" v-model="value2" width="50">
                    <Button style="margin-top: 3px;" size="small" type="primary" @click="onClearHistorySimNums">清空历史
                    </Button>
                    <Button style="margin-top: 3px; display:block;" size="small" :type="item.recvNew"
                            v-for="(item, index) in historySimNums" @click="onHistoryClick(item)">{{item.simNum}}
                    </Button>
                </Drawer>
            </div>
            <div v-if="simInfo && simNum" style="margin-top: 10px; margin-bottom: 10px;position: fixed;right: 10px">
                <label>{{simInfo.content[0].simNum}}</label>
                <label v-if="simInfo.content[0].operation == 1">中国移动</label>
                <label v-if="simInfo.content[0].operation == 2">中国联通</label>
                <label v-if="simInfo.content[0].operation == 3">中国电信</label>
                <label v-if="simInfo.content[0].operation == 4">珠海移动专网</label>
            </div>
            <div v-if="simInfo" style="margin-top: 30px; margin-bottom: 10px;position: fixed;right: 10px">
                <label>{{simInfo.content[0].remark}}</label>
            </div>

        </div>
        <div style="position: fixed;top: 100px;right: 5px;width: 80%">
            <Scroll :height="scrollHeight" ref="shortMessageScroll">
                <div id="smscontent" class="message-history">
                    <div v-for="sms in shortMessageContent">
                        <div v-if="sms.direction === 1">
                            <div class="message-receive">
                                <div class="message-time">{{new Date(sms.createDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</div>
                                <div class="message-info">
                                    <!--                                <div class="user-info">-->
                                    <!--                                    <img class="user-avatar" src="/smshead.jpg"/>-->
                                    <!--                                </div>-->
                                    <div class="message-content-box">
                                        <div class="arrow"></div>
                                        <div class="message-content">{{sms.content}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="message-reply">
                                <div class="message-time">{{new Date(sms.createDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</div>
                                <div class="message-info">
                                    <!--                                <div class="user-info">-->
                                    <!--                                    <img class="user-avatar" src="/smshead.jpg"/>-->
                                    <!--                                </div>-->
                                    <div class="message-content-box">
                                        <div class="arrow"></div>
                                        <div class="message-content">{{sms.content}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--        <div style="position: fixed;right: 50%">-->
<!--                <div>-->
<!--                    <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;-->
<!--                            align-items: center;-->
<!--                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="list_loadding">-->
<!--                        <Spin size="large"></Spin>-->
<!--                        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>-->
<!--                    </div>-->
<!--                </div>-->
            </Scroll>
        </div>
        <div style="position: fixed;bottom: 10px;right: 5px;width: 80%">
            <Input v-model="sendContent" type="textarea" placeholder="请输入短信内容" clearable style="margin-bottom: 5px"></Input>
            <Button size="small" type="primary" @click="onSendCKBSJClick" style="margin-right: 5px">查询参数</Button>
            <Button size="small" type="primary" @click="onSetupParamsClikc" style="margin-right: 5px">设置参数</Button>
            <Button size="small" type="primary" @click="clearSendContent" style="margin-right: 5px">清空</Button>
            <br>
            <Button size="small" type="primary" @click="onSendCKVERClick" style="margin-right: 5px;margin-top: 5px">查询版本</Button>
            <Button size="small" type="primary" @click="onInitClick" style="margin-right: 5px;margin-top: 5px">初始化设备</Button>
            <Button size="small" type="primary" @click="onSendShortMessageClick" style="margin-right: 5px;margin-top: 5px">发送</Button>
        </div>

        <Modal
                v-model="setupBsjParamsSmsModal"
                title="短信设置BSJ终端参数"
                @on-ok="ok"
                @on-cancel="cancel">
                    <label style="display: inline-block; width: 200px;">主机号(如不修改请留空)</label>
                    <Input style="display: inline-block; width: 200px;" v-model="deviceParams.terminalNum" placeholder="请输入主机号">
                    </Input>
                    <label style="display: inline-block; width: 200px;">服务器IP</label>
                    <Input style="display: inline-block; width: 200px;" v-model="deviceParams.ip" placeholder="请输入服务器IP">
                    </Input>
                    <label style="display: inline-block; width: 200px;">服务器端口</label>
                    <Input style="display: inline-block; width: 200px;" v-model="deviceParams.port" placeholder="请输入服务器端口">
                    </Input>
                    <label style="display: inline-block; width: 200px;">APN</label>
                    <Input style="display: inline-block; width: 200px;" v-model="deviceParams.apn" placeholder="请输入APN">
                    </Input>
                    <label style="display: inline-block; width: 200px;">ACC开上传间隔</label>
                    <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;" v-model="deviceParams.accOn" placeholder="请输入ACC开上传间隔">
                    </InputNumber>
                    <label style="display: inline-block; width: 200px;">ACC关上传间隔</label>
                    <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;" v-model="deviceParams.accOff" placeholder="请输入ACC关上传间隔">
                    </InputNumber>
        </Modal>

        <Modal
                v-model="initBsjSmsModal"
                title="短信初始化BSJ终端"
                @on-ok="okBSJINI"
                @on-cancel="cancel">
            <label style="display: inline-block; width: 200px;">主机号(初始化必填)</label>
            <Input style="display: inline-block; width: 200px;" v-model="deviceParams.terminalNum" placeholder="请输入主机号">
            </Input>
            <label style="display: inline-block; width: 200px;">服务器IP</label>
            <Input style="display: inline-block; width: 200px;" v-model="deviceParams.ip" placeholder="请输入服务器IP">
            </Input>
            <label style="display: inline-block; width: 200px;">服务器端口</label>
            <Input style="display: inline-block; width: 200px;" v-model="deviceParams.port" placeholder="请输入服务器端口">
            </Input>
            <label style="display: inline-block; width: 200px;">APN</label>
            <Input style="display: inline-block; width: 200px;" v-model="deviceParams.apn" placeholder="请输入APN">
            </Input>
            <label style="display: inline-block; width: 200px;">ACC开上传间隔</label>
            <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;" v-model="deviceParams.accOn" placeholder="请输入ACC开上传间隔">
            </InputNumber>
            <label style="display: inline-block; width: 200px;">ACC关上传间隔</label>
            <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;" v-model="deviceParams.accOff" placeholder="请输入ACC关上传间隔">
            </InputNumber>
        </Modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import config from '@/config'
    import store from '@/store'
    import Cookies from 'js-cookie';
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "short-messages",
        data() {
            return {
                value2: false,
                //搜索列表
                searchSimLoading: false,
                searchSimList: [],
                simNum: '',
                //历史查询
                historySimNums: [],

                simInfo: null,

                //页数
                pageIndex: 0,

                //对话内容
                list_loadding: false,
                shortMessageContent: [],

                // 设置BSJ终端参数
                setupBsjParamsSmsModal: false,
                setupBsjParamsSmsSimNum: null,

                // 初始化BSJ终端
                initBsjSmsModal: false,
                initBsjSmsSimNum: null,

                //短信内容
                sendContent: '',

                //对话框
                scrollHeight: 250,

                sort: {name: 'createDatetime', asc: false},

                websock: null,

                //定时器
                timer:null,

                deviceParams: {
                    ip:null,
                    port:null,
                    apn:null,
                    terminalNum:null,
                    accOn:null,
                    accOff:null
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.scrollHeight = window.innerHeight - 240
                window.onresize = () => {
                    this.scrollHeight = window.innerHeight - 240
                }

                if (this.$route.params) {
                    this.simNum = this.$route.params.simNum
                    if (this.simNum != null) {
                        this.onSearchClick()
                    }
                }

                this.pageIndex = 1;

                if (this.timer){
                    clearInterval(this.timer)
                }
                // setInterval(this.setPage,5000)

                this.historySimNums = Cookies.get('historySimNums')
                if(!this.historySimNums){
                    this.historySimNums = []
                }else{
                    this.historySimNums = JSON.parse(this.historySimNums)
                }

                if (this.websock === null) {
                    this.initWebSocket();
                } else {
                    this.websock.close();
                    this.websock = null;
                    this.initWebSocket();
                }

                this.deviceParams.ip = '112.74.160.123'
                this.deviceParams.port = 2010
                this.deviceParams.apn = 'CMNET'
                this.deviceParams.terminalNum = null
                this.deviceParams.accOn = 15
                this.deviceParams.accOff = 120

            });

        },
        methods: {
            ok(){
                let content = '<SPBSJ*P:BSJGPS'

                if(this.deviceParams.ip && this.deviceParams.port && this.deviceParams.ip !== '' && this.deviceParams.port !== ''){
                    content = content + '*T:' + this.deviceParams.ip + ',' + this.deviceParams.port
                }

                if(this.deviceParams.terminalNum && this.deviceParams.terminalNum !== ''){
                    content = content + '*N:' + this.deviceParams.terminalNum
                }

                if(this.deviceParams.apn && this.deviceParams.apn !== ''){
                    content = content + '*A:' + this.deviceParams.apn
                }

                if(this.deviceParams.accOn && this.deviceParams.accOn !== ''){
                    content = content + '*C:' + this.deviceParams.accOn
                }

                if(this.deviceParams.accOff && this.deviceParams.accOff !== ''){
                    content = content + '*O:' + this.deviceParams.accOff
                }

                content = content + '>'

                store.dispatch('ShortMessageServ_Send', {params: {simNum: this.simNum, content: content}}).then(() => {
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            okBSJINI(){
                let content = '<SPBSJ*P:BSJINI'

                if(this.deviceParams.ip && this.deviceParams.port && this.deviceParams.ip !== '' && this.deviceParams.port !== ''){
                    content = content + '*T:' + this.deviceParams.ip + ',' + this.deviceParams.port
                }

                if(this.deviceParams.terminalNum && this.deviceParams.terminalNum !== ''){
                    content = content + '*N:' + this.deviceParams.terminalNum
                }

                if(this.deviceParams.apn && this.deviceParams.apn !== ''){
                    content = content + '*A:' + this.deviceParams.apn
                }

                if(this.deviceParams.accOn && this.deviceParams.accOn !== ''){
                    content = content + '*C:' + this.deviceParams.accOn
                }

                if(this.deviceParams.accOff && this.deviceParams.accOff !== ''){
                    content = content + '*O:' + this.deviceParams.accOff
                }

                content = content + '>'

                store.dispatch('ShortMessageServ_Send', {params: {simNum: this.simNum, content: content}}).then(() => {
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            cancel(){},

            onShortMessageDataFrame(result, websock){
                console.log('onShortMessageDataFrame')
                let frame = result.frame
                console.log(frame)
                let newItem = {
                    simNum: frame.simNum,
                    content: frame.smsContent,
                    direction: frame.direction,
                    createDatetime: 0
                }
                console.log(newItem)
                this.historySimNums.forEach(item => {
                    if (item.simNum === newItem.simNum && newItem.direction === 1) {
                        console.log('收到新消息')
                        item.recvNew = 'warning'
                    } else {
                        item.recvNew = 'default'
                    }
                })
                Cookies.set('historySimNums', this.historySimNums, {expires: 7})
                if (this.simNum === newItem.simNum) {
                    this.shortMessageContent.unshift(newItem)
                }
            },
            websocketonmessage(e) { //数据接收
                console.log('接收到数据')
                let result = jcicpDecode(e.data)
                console.log(result)
                if(result.frameTypeName === 'ShortMessageDataFrame'){
                    console.log('result.name')
                    this.onShortMessageDataFrame(result, this.websock)
                }
            },
            initWebSocket() { //初始化weosocket
                //ws地址
                const wsuri = config.baseUrl.pro_ws + "/websocket";
                this.websock = new WebSocket(wsuri);
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onopen = this.websocketonopen;
                this.websock.onclose = this.websocketclose;
                this.websock.binaryType = 'arraybuffer'
            },
            websocketonopen(event) {
                console.log('Websocket连接打开');
            },
            websocketclose(e) {  //关闭
                console.log("connection closed (" + e.code + ")");
            },
            //发送短信
            onSendShortMessageClick() {
                this.sendSMS(this.sendContent)
            },
            //初始化设备
            onInitClick(){
                if (!this.simNum || this.simNum === '') {
                    this.$Message.error('请选择SIM卡号')
                    return
                }
                this.initBsjSmsSimNum = this.simNum
                this.initBsjSmsModal = true
            },
            //查询版本
            onSendCKVERClick() {
                this.sendSMS('<CKVER>')
            },
            //设置参数
            onSetupParamsClikc() {
                if (!this.simNum || this.simNum === '') {
                    this.$Message.error('请选择SIM卡号')
                    return
                }
                this.setupBsjParamsSmsSimNum = this.simNum
                this.setupBsjParamsSmsModal = true
            },
            //查询参数
            onSendCKBSJClick() {
                this.sendSMS('<CKBSJ>')
            },
            //清空
            clearSendContent() {
                this.sendContent = '';
            },
            sendSMS(content) {
                if (!this.simNum || this.simNum === '') {
                    this.$Message.error('请选择SIM卡号')
                    return
                }
                store.dispatch('ShortMessageServ_Send', {params: {simNum: this.simNum, content: content}}).then(() => {
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            //sim选择
            searchSim(input) {
                this.searchSimLoading = true;
                if (!input || input.length <= 0) {
                    this.searchSimList = [];
                    this.searchSimLoading = false;
                } else {
                    store.dispatch('SimInfoServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchSimList = store.getters.get_SimInfo_SearchByNameResult ? store.getters.get_SimInfo_SearchByNameResult : [];
                        this.searchSimLoading = false;
                    }).catch(err => {
                        console.log(err);
                        this.searchSimLoading = false;
                    });
                }
            },
            //根据sim卡查询
            onSearchClick() {
                if (!this.simNum || this.simNum === '') {
                    this.$Message.error('请选择SIM卡号')
                    return
                }
                if (!this.existHistorySimNum(this.simNum)) {
                    this.historySimNums = [{simNum: this.simNum, recvNew: false}].concat(this.historySimNums)
                    Cookies.set('historySimNums', this.historySimNums, {expires: 7})
                }
                this.setPage()
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.timer = setInterval(this.setPage,5000)
            },
            sortChange({column, key, order}) {
                this.sort = {
                    name: key,
                    asc: order === 'asc' ? true : false
                }
                this.refreshPage();
            },
            existHistorySimNum(simNum) {
                let index = -1
                for (var i = 0; i < this.historySimNums.length; i++) {
                    if (this.historySimNums[i].simNum === simNum) {
                        return true
                    }
                }
                return false
            },
            threadPoxi() {  // 实际调用的方法
                //参数
                const agentData = 'mymessage';
                //若是ws开启状态
                if (this.websock.readyState === this.websock.OPEN) {
                    this.websocketsend(agentData)
                }
                // 若是 正在开启状态，则等待300毫秒
                else if (this.websock.readyState === this.websock.CONNECTING) {
                    let that = this;//保存当前对象this
                    setTimeout(function () {
                        that.websocketsend(agentData)
                    }, 300);
                }
                // 若未开启 ，则等待500毫秒
                else {
                    this.initWebSocket();
                    let that = this;//保存当前对象this
                    setTimeout(function () {
                        that.websocketsend(agentData)
                    }, 500);
                }
            },
            websocketsend() {//数据发送
                this.websock.send(agentData);
            },
            //清空查询历史
            onClearHistorySimNums() {
                Cookies.remove('historySimNums')
                this.historySimNums = []
            },
            //点击历史查询回调
            onHistoryClick(item) {
                let simNum = item.simNum
                item.recvNew = 'default'
                console.log(simNum)
                this.simNum = simNum
                this.onSearchClick()
                this.setPage()
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.timer = setInterval(this.setPage,5000)
            },
            //刷新当前页
            refreshPage() {
                    this.setPage(this.pageIndex)
            },
            setPage(page) {

                if (this.simNum && this.simNum != '') {
                    store.dispatch('SimInfoServ_GetPage', {
                        params: null,
                        urlparams: {
                            q: genQueryParam('simNum', 'EQ', this.simNum)
                        },
                    }).then(() => {
                        this.simInfo = store.getters.get_SimInfo_GetPageResult;
                        console.log('SimServ_GetAll');
                        console.log(this.simInfo);
                    }).catch(err => {
                        this.$Message.error(err);
                    });
                }


                this.pageIndex = page;
                this.list_loadding = true;

                let queryParam = null;
                let sortParam = null;

                if (this.simNum !== null && this.simNum !== undefined && this.simNum.trim() !== '') {
                    this.simNum = this.simNum.trim();
                    queryParam = genQueryParam('simNum', 'EQ', this.simNum);
                }

                if (this.sort !== null && this.sort !== undefined) {
                    sortParam = genSortParam(this.sort.name, this.sort.asc);
                }

                store.dispatch('ShortMessageServ_GetPage', {
                    params: null,
                    urlparams: {
                        q: queryParam,
                        keyword: this.keywordFilter,
                        sort: sortParam
                    }
                }).then(() => {
                    this.list_loadding = false;
                    console.log(this.content);
                    this.shortMessageContent = this.content;
                    // if (this.simNum !== null && this.simNum !== undefined && this.simNum !== '') {
                    //     this.subscribe([this.simNum])
                    // }
                }).catch(err => {
                    this.list_loadding = false;
                    this.$Message.error(err);
                })
            },

            // subscribe(simNums) {
            //     let subscribeSmsFrameBuilder = jcicp.lookup('SubscribeSmsFrame')
            //     let subscribeSmsFrame = subscribeSmsFrameBuilder.create({
            //         selectAll:false,
            //         simNums:simNums
            //     })
            //     let buffer = subscribeSmsFrameBuilder.encode(subscribeSmsFrame).finish();
            //     let data = jcicpEncode('SubscribeSmsFrame', buffer)
            //     this.websock.send(data);
            // },

        },
        computed: {
            content() {
                if (store.getters.get_ShortMessage_GetPageResult) {
                    return store.getters.get_ShortMessage_GetPageResult.content;
                } else {
                    return [];
                }

            },
        }
    }
</script>

<style scoped>
    .message-history {
        border-radius: 5px;
        border: 2px solid #EEE;
        min-width: 100px;
        margin: auto;
        padding: 10px;
        font-size: 12px;
    }

    .message-time {
        height: 20px;
        line-height: 18px;
    }

    .message-receive .message-time {
        margin-left: 60px;
        text-align: left;
    }

    .message-reply .message-time {
        margin-right: 60px;
        text-align: right;
    }

    .message-info {
        position: relative;
        overflow: hidden;
    }

    .message-content-box {
        border-radius: 5px;
        position: relative;
        padding: 15px;
        word-break: break-word;
    }

    .message-reply .message-content-box {
        background: #b8db29;
        color: #333;
        margin-right: 10px;
        float: right;
    }

    .message-receive .message-content-box {
        background: #CCC;
        color: #333;
        margin-left: 10px;
        float: left;
    }

    .message-content-box .arrow {
        width: 0;
        height: 0;
        font-size: 0;
        border-width: 10px;
        border-style: solid;
        position: absolute;
        top: 10px;
    }

    .message-reply .message-content-box .arrow {
        border-color: transparent transparent transparent #b8db29;
        right: -20px;
    }

    .message-receive .message-content-box .arrow {
        border-color: transparent #CCC transparent transparent;
        left: -20px;
    }

    .item-pics-box {
        float: left;
        margin-right: 10px;
    }

    .item-pic {
        width: 40px;
        height: 40px;
    }

    .message-content {
        overflow: hidden;
    }

    .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 25px;
        position: absolute;
        top: 0;
    }

    .message-receive .user-avatar {
        left: 0;
    }

    .message-reply .user-avatar {
        right: 0;
    }

    .send-message {
        position: relative;
        margin-top: 7px;
        height: 40px;
    }

    .send-message .send-msg-btn {
        float: right;
        width: 75px;
        line-height: 38px;
        height: 38px;
        margin-left: 5px;
        font-size: 14px;
        background-color: #FDFDFD;
        border: 1px solid #D7D7D7;
        text-align: center;
    }

    .send-message .message-input-box {
        border-radius: 3px;

        background-size: 11px 11px;
        background-repeat: no-repeat;
        background-position: 6px 14px;
        padding: 0 0 0 25px;
        background-color: #F9F9F9;
        border: 1px solid #D7D7D7;
        overflow: hidden;
    }

    .send-message input.message-input {
        margin: 0;
        padding: 8px 0;
        font-size: 16px;
        width: 100%;
        height: 100%;
        border: none;
    }

    .demo-split {
        height: 100%;
        border: 1px solid #dcdee2;
    }

    .demo-split-pane {
        padding: 10px;
    }
</style>
